import * as React from 'react';
import { View, StyleSheet } from 'react-native';
import { Modal, ImageButton } from 'secullum-react-native-ui';
import InconsistenciaDetalhes from '../../../shared/components/InconsistenciaDetalhes';
import ModalInconsistenciaJustificar from '../../../shared/components/ModalInconsistenciaJustificar';
import { getTheme } from '../../../shared/modules/layout';
import {
  InconsistenciasDados,
  InconsistenciasStatus
} from '../../../shared/modules/types';

interface Props {
  inconsistencia: InconsistenciasDados;
  modalVisible: boolean;
  onCancelar: () => void;
  onConcluir: () => void;
}

class InconsistenciasDetalhes extends React.Component<Props> {
  renderJustificarHoras = () => {
    const { onCancelar, onConcluir, inconsistencia } = this.props;

    return (
      <ModalInconsistenciaJustificar
        inconsistencia={inconsistencia}
        onCancelar={onCancelar}
        onConcluir={onConcluir}
      />
    );
  };

  renderDetalhes = () => {
    const { modalVisible, inconsistencia, onCancelar } = this.props;

    return (
      <>
        <Modal visible={modalVisible} overlayStyle={{ overflow: 'scroll' }}>
          <View style={styles.modalContainer}>
            <View style={styles.modalIcons}>
              <ImageButton
                style={styles.imageButtonClose}
                icon="close"
                onPress={() => onCancelar()}
                nativeID="botao-fechar-detalhe"
              />
            </View>
            <View nativeID="inconsistencia-detalhe" style={styles.modalSection}>
              <InconsistenciaDetalhes inconsistencia={inconsistencia} />
            </View>
          </View>
        </Modal>
      </>
    );
  };

  render() {
    const { inconsistencia } = this.props;

    if (!inconsistencia) {
      return null;
    }

    return inconsistencia.status !== InconsistenciasStatus.Pendente
      ? this.renderDetalhes()
      : this.renderJustificarHoras();
  }
}

const theme = getTheme();

const styles = StyleSheet.create({
  modalContainer: {
    margin: 'auto',
    width: '90%',
    maxWidth: 366,
    backgroundColor: theme.backgroundColor2,
    borderRadius: 10,
    justifyContent: 'center'
  },
  modalIcons: {
    flexDirection: 'row'
  },
  modalSection: {
    width: '90%',
    alignSelf: 'center'
  },
  imageButtonClose: {
    borderWidth: 0,
    marginLeft: 'auto'
  }
});

export default InconsistenciasDetalhes;
